import { barbPath as buildBarbPath } from '../../lib/windgram/barbs';

const MS_TO_KT = 1.94384;
const CALM_KT_THRESHOLD = 5;
const PENNANT_KT = 50;
const FULL_KT = 10;
const HALF_KT = 5;

// Skysight-style horizontal-stem barb.
// Origin (0,0) is the anchor (placed at grid x,y). The shaft runs horizontally
// from x=-10 to x=10 at y=-2.5. The TAIL TICK (open end into the wind source) is
// at the left end. Features extend UPWARD from the shaft.
//
// Rotation convention: dirDeg is the meteorological "FROM" direction (clockwise
// from north). At rotate(0), the tail points LEFT (west). To rotate it to compass
// north we add 90°. So the final transform applies rotate(dirDeg + 90).
const SCALE = 0.9;
const ROTATION_OFFSET = 90;

const WindBarb = ({ speedMs, dirDeg, color = 'currentColor', x = 0, y = 0 }) => {
    const knots = (speedMs || 0) * MS_TO_KT;

    if (knots < CALM_KT_THRESHOLD) {
        return (
            <g transform={`translate(${x},${y})`} data-testid="barb-root">
                <circle cx={0} cy={0} r={1.8} fill="none" stroke={color} strokeWidth={1} data-testid="barb-calm" />
            </g>
        );
    }

    // Per-feature counts (used as keys for hidden test markers)
    let remaining = Math.round(knots / 5) * 5;
    const pennants = Math.floor(remaining / PENNANT_KT); remaining -= pennants * PENNANT_KT;
    const fulls = Math.floor(remaining / FULL_KT); remaining -= fulls * FULL_KT;
    const halves = Math.floor(remaining / HALF_KT);

    return (
        <g
            transform={`translate(${x},${y}) rotate(${(dirDeg || 0) + ROTATION_OFFSET}) scale(${SCALE})`}
            data-testid="barb-root"
        >
            <path
                d={buildBarbPath(knots)}
                stroke={color}
                fill={color}
                strokeWidth={1.6}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            {/* Invisible markers so the existing tests can count rendered feature types. */}
            {Array.from({ length: pennants }).map((_, i) => (
                <metadata key={`p${i}`} data-testid="barb-pennant" />
            ))}
            {Array.from({ length: fulls }).map((_, i) => (
                <metadata key={`f${i}`} data-testid="barb-full" />
            ))}
            {Array.from({ length: halves }).map((_, i) => (
                <metadata key={`h${i}`} data-testid="barb-half" />
            ))}
        </g>
    );
};

export default WindBarb;
